import Loader from "./Loader"
import React from "react"

export interface ProgressionStatus {
  status: 'idle' | 'pending' | 'success' | 'error'
  message?: string
}
interface Props {
  status: ProgressionStatus
}
export default function ActivityProgression({ status }: Props): JSX.Element {
  return (
    <div className='w-full h-full flex flex-col items-center justify-center'>
      <div className='h-14 w-14 flex items-center justify-center'>
        {status.status === 'pending' && <Loader className="h-8 w-8" />}
      </div>
      {status.message && <p className='font-bvp_semibold text-xl'>{status.message}</p>}
    </div>
  )
}
